import React from 'react';

const EmojiPicker = ({ isOpen, onClose, onSelect, options }) => {
    if (!isOpen) {
        return null;
    }

    const styles = {
        overlay: {
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            zIndex: 1050,
        },
        picker: {
            position: 'fixed',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            backgroundColor: 'white',
            borderRadius: '8px',
            padding: '1rem',
            boxShadow: '0 5px 15px rgba(0,0,0,0.3)',
            width: '320px',
            zIndex: 1051,
        },
        title: {
            textAlign: 'center',
            marginTop: 0,
            color: '#333',
        },
        gridContainer: {
            maxHeight: '300px',
            overflowY: 'auto',
            padding: '0.5rem',
            border: '1px solid #eee',
            borderRadius: '4px',
        },
        grid: {
            display: 'grid',
            gridTemplateColumns: 'repeat(5, 1fr)',
            gap: '0.5rem',
        },
        emojiButton: {
            backgroundColor: '#f8f9fa',
            border: '1px solid #dee2e6',
            borderRadius: '4px',
            padding: '0.5rem',
            fontSize: '1.5rem',
            cursor: 'pointer',
            transition: 'background-color 0.2s',
        }
    };

    return (
        <div style={styles.overlay} onClick={onClose}>
            <div style={styles.picker} onClick={(e) => e.stopPropagation()}>
                <h3 style={styles.title}>انتخاب نماد</h3>
                <div style={styles.gridContainer}>
                    <div style={styles.grid}>
                        {options.map((emoji, index) => (
                            <button
                                key={index}
                                style={styles.emojiButton}
                                onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#e9ecef'}
                                onMouseOut={(e) => e.currentTarget.style.backgroundColor = '#f8f9fa'}
                                onClick={() => onSelect(emoji)}
                            >
                                {emoji || '⌫'}
                            </button>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default EmojiPicker;
